module.exports = __webpack_public_path__ + "img/4m.b2049cc0.png";